import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  // Rejtve marad, amíg nincs valódi RAJZ KÉSZ vélemény a data/content.ts-ben
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-271" data-mp="3fym5ug9teu28">
      <div className="mx-auto max-w-6xl" data-id="element-272" data-mp="3azjefymrcmcq">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-273" data-mp="3ayqdxfee6t31">
          Mit <em className="text-red-700" data-id="element-274" data-mp="31zw8r0mzwudv">mondanak</em> a tanárok
        </h2>
        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-275" data-mp="31yl8vbwo86s1">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-276" data-mp="2s1q8engu7wb4">
              <div className="text-sm text-amber-500" aria-label="5 csillagból 5" data-id="element-277" data-mp="2s3jhsaiu4umt">
                <span aria-hidden="true" data-id="element-278" data-mp="v85b00rzzj4d">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-279" data-mp="qa3pzab0h9q9">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-280" data-mp="h8145e8mjyfq">
                <span className="font-semibold text-slate-900" data-id="element-281" data-mp="m62os3lp85tb">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-282" data-mp="78aa1dnz7lg6"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}